import { runClientComponent } from '../../_common/client/client-component-runner';
import { ProductComparisonApiComponent } from './product-comparison-api.component';

runClientComponent({ ProductComparisonApiComponent });
